/* global app */
app.controller('dialog_simpleChoiceCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', function ($rootScope, $scope, $http, NetworkService, MainService) {
    
        $scope.fields = {};
    }])